import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { apiKey } from "../../config/config";

function ThankYou() {
  const [orderDetails, setOrderDetails] = useState("");
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const orderId = queryParams.get("orderId");

  function convertDateTimeToDate(datetimeString) {
    const date = new Date(datetimeString); // Parse the datetime string to a Date object
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed, so add 1
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`; // Return formatted date string
  }

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/customer/fetch_order/${orderId}`)
      .then((res) => {
        setOrderDetails(res.data);
      })
      .catch((err) => {})
      .finally(() => {
        setLoading(false);
      });
  }, [orderId]);

  if (loading) {
    return (
      <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
        <img src="/assets/gif/dash2.gif" alt="" />
      </div>
    );
  }

  if (orderDetails?.order_type?.name === "Dine-in")
    return (
      <main>
        <section className="py-16">
          <div className="w-[90%] max-w-7xl mx-auto">
            <div>
              <img
                className="max-w-[400px] mx-auto"
                src="/assets/icon_confirmation.gif"
                alt=""
              />
            </div>
            <div className="text-center ">
              <h1 className="text-4xl font-semibold">Thank You!</h1>
              <p className="text-3xl font-medium mt-4 text-w-bg">
                Your order for {orderDetails?.table?.name} has been placed
                successfully.
              </p>
              <p className="font-bold">
                For any query please call any waiter nearer to your table.
              </p>
              <div className="flex justify-center w-fit flex-col text-w-btn-text font-bold text-lg rounded-md py-2 px-4 mt-5 border border-w-border bg-w-btn mx-auto">
                <Link to={"/"} className="flex justify-center">
                  Continue To Homepage
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
    );
  if (
    orderDetails?.order_type?.name === "Delivery" ||
    orderDetails?.order_type?.name === "Take away"
  )
    return (
      <main>
        <section className="py-16">
          <div className="max-w-xl w-full mx-auto rounded border-t-2 border-b-2 border-w-border shadow-lg">
            <div className="px-8">
              <h1 className="text-center font-semibold text-w-heading text-4xl mt-2">
                Thank You!
              </h1>
              <h2 className="text-w-bg font-semibold text-3xl mt-4">
                Order Summary
              </h2>
              <div className="grid grid-cols-2 gap-x-4 mt-8 text-gray-500 font-bold text-sm">
                <span>
                  Tracking Number:{" "}
                  <Link className="underline text-blue-600">
                    {orderDetails?.sale_no}
                  </Link>
                </span>
                <span>
                  {orderDetails?.order_type?.name === "Delivery" &&
                    "Delivery Address"}
                </span>
                <span>
                  Order Time {convertDateTimeToDate(orderDetails?.sale_date)}{" "}
                  {orderDetails?.order_time}
                </span>
                <span>
                  {orderDetails?.order_type?.name === "Delivery" &&
                  orderDetails?.is_guest === "yes"
                    ? orderDetails?.guest.address
                    : orderDetails?.address}
                </span>
              </div>
            </div>
            <div className="px-8 py-6 leading-loose bg-gray-100 mt-8">
              <p>
                Hey (
                {orderDetails?.is_guest === "yes"
                  ? orderDetails?.guest.name
                  : orderDetails?.customer.name}
                ), Well chosen. Your order from (IMDADY) is on its way. If there
                is anything else you need, please head over to the Help number
                (966535090666) for assistance.
              </p>
            </div>
            <div className="flex justify-evenly items-center">
              <img
                className="w-16"
                src="/assets/logo/logo_no_text.png"
                alt=""
              />
              <p className="text-lg">&copy; 2025 Imdady</p>
            </div>

            <div className="flex gap-4 justify-evenly items-center my-6">
              <Link
                to={"/"}
                className="text-w-btn-text bg-w-btn font-medium rounded-md py-1 px-2"
              >
                Continue To Homepage
              </Link>
              <Link className="text-w-btn-text bg-w-btn font-medium rounded-md py-1 px-2">
                Track Your Order
              </Link>
            </div>
          </div>
        </section>
      </main>
    );
}

export default ThankYou;
